import React, { useState, useEffect, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import '../../index.css';

import { getBotSessions } from '../../../../../../store/actions/reports';
import sessionIcon from '../../../../../../assets/images/sessions.svg';
import ContainerReport from '../../../ContainerReport';

/**
 * Component for show the bot sessions report
 *
 * @param {*} props
 * @returns
 */
const QntSessionReport = (props) => {
  const { match, user, getBotSessions, sessions, componentData, bot } = props;
  const {
    parentFilter,
    draggableId,
    onRemoveClick,
    isEditMode,
  } = componentData;

  const { botid } = match.params;
  const { startDate, endDate } = parentFilter;
  const token = user.dashboard_token;

  const [sessionsTotal, setSessionsTotal] = useState(0);
  const [sessionsAverage, setSessionsAverage] = useState(0);
  const [timezone, setTimezone] = useState('');

  /**
   * Called for fetch new data for this component
   */
  useEffect(() => {
    if (bot && bot.settings && bot.settings.timezone) {
      setTimezone(bot.settings.timezone.fuso);
    }
  },[bot]);

  useEffect(() => {
    if (user && timezone !== '') {
      const { nameTags, channels, variables } = parentFilter;
      getBotSessions(botid, token, {
        startDate,
        endDate,
        tags: nameTags,
        channels,
        variables,
        timezone
      });
    }
  }, [parentFilter, user, timezone]);

  /**
   * Called for render the component and change values on UI
   */
  useEffect(() => {
    setSessionsTotal(getSessionsTotal());
    setSessionsAverage(getSessionsAverage());
  }, [sessions.total]);

  /**
   * Get the total sessions
   */
  const getSessionsTotal = () => {
    if (
      !sessions ||
      !Array.isArray(sessions.total) ||
      sessions.total.length === 0
    ) {
      return 0;
    }
    return sessions.total[0].total;
  };

  /**
   * Get the sessions average
   */
  const getSessionsAverage = () => {
    if (
      !sessions ||
      !Array.isArray(sessions.average) ||
      sessions.average.length === 0
    ) {
      return 0;
    }

    return sessions.average[0].media;
  };

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    return (
      <Fragment>
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">{sessionsTotal}</p>
          <span className="tipo-relatorio">Total</span>
        </div>
        {/* <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio">
          <p className="result-relatorio-green">{sessionsAverage}</p>
          <span className="tipo-relatorio">Média</span>
        </div> */}
      </Fragment>
    );
  };

  return (
    <ContainerReport
      type="absolute"
      icon={sessionIcon}
      title="Sessões"
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    sessions: {
      total: state.reports.botSessions.total,
      average: state.reports.botSessions.average,
      bot: state.bots.bot
    },
    bot: state.bots.bot
  };
};

const mapDispatchToprops = (dispatch) => {
  return bindActionCreators({ getBotSessions }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToprops)(QntSessionReport)
);
